import React, { useState, useEffect} from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import Card from '../../../components/Card'
import { getApiCall} from '../../../service/httpCall';
import { DataTable } from 'primereact/datatable';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Column } from 'primereact/column';
import RenderDeleteModal from '../../../components/partials/components/delete-modal';
import ToastNotification from '../../../components/Toast';
import { API_JOURNEY_OPERATION_LIST} from '../../../service/url';
import Loader  from '../../../components/partials/components/loader';
import exportData from '../../../utilities/export';
import { exportToCSV, hasPermission } from '../../../utilities/helpers';
import { getUser } from "../../../utilities/setting";
//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';
//core
import 'primereact/resources/primereact.min.css';
import {errorCheck } from '../auth/auth-utils';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import "../../../assets/custom/css/custom.css";


export default function JourneyOperationList() {
   const navigate = useNavigate();
   const [operationList, setOperationList] = useState([]);
   const [enableDeleteModal, setEnableDeleteModal] = useState(false);
   const [confirmDelete, setConfirmDelete] = useState(false);
   const [filters, setFilters] = useState({
      module_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      action: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
      'creator.username':{ operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
  });
   const [showToast, setShowToast] = useState(false);
   const [toastProps, setToastProps] = useState(null);
   const [loading, setLoading] = useState(false);
   const [buttonDisable, setButtonDisable] = useState(false);
   const [searchValue, setSearchValue] = useState(null);
   const [originalDataList, setOriginalDataList] = useState([]);

   const handleExport = async () => {
   try {
      setButtonDisable(true);

      exportToCSV({
         fileName: "activity-list",
         data: operationList,
         columns: [
            {
               header: "#",
               accessor: "key"
            },
            {
               header: "Module Name",
               accessor: (row) =>
                  row.module_name?.toUpperCase()
            },
            {
               header: "Action",
               accessor: (row) =>
                  row.action?.toUpperCase()
            },
            {
               header: "Action By",
               accessor: (row) =>
                  row.creator?.username || "-"
            },
            {
               header: "Date",
               accessor: (row) =>
                  new Date(row.created_at).toLocaleString(
                     "en-IN",
                     {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                     }
                  )
            }
         ]
      });

   } finally {
      setButtonDisable(false);
   }
};

   useEffect(() => {

      if (toastProps) {
         setShowToast(true);
      }

   }, [toastProps]);

   useEffect(() => {
      setLoading(true);
      getApiCall(API_JOURNEY_OPERATION_LIST)
         .then(onOperationListSuccess)
         .catch(onError)
         .finally(() => setLoading(false));

   }, []);

   const [moduleOperationsForReadPermissionCheck, setModuleOperationsForReadPermissionCheck] = useState({});
   
     useEffect(() => {
      const user = getUser();
         if (user) {
           if (user?.acl_settings) {    
             setModuleOperationsForReadPermissionCheck(JSON.parse(user.acl_settings.module_operations));
           }
         }
     }, []);


   function onOperationListSuccess(resp) {
      const updatedList = resp.map((val, idx) => {
         val['key'] = idx + 1;
         //val['actions'] = RenderActionComponent(val.id);
         val['created_at'] = new Date(val['created_at']).toGMTString();
         return val;
      });
      setOperationList(updatedList);
      setOriginalDataList(updatedList);
   }

  useEffect(() => {
    if (searchValue) {
        const filtered = originalDataList.filter((data) =>
            data.module_name?.toLowerCase().includes(searchValue.trim().toLowerCase())
        );
        setOperationList(filtered);
    } else {
        setOperationList(originalDataList);
    }
}, [searchValue, originalDataList]);


const fetchActivityList = async () => {
    setLoading(true);
    try {
        const resp = await getApiCall(API_JOURNEY_OPERATION_LIST);
        onOperationListSuccess(resp);
    } catch (err) {
        onError(err);
    } finally {
        setLoading(false);
    }
};

const handleRefresh = () => {
    setSearchValue(""); 
    fetchActivityList(); 
};




   const dropdownItemTemplate = (option) => {
      return <span>{option}</span>;
   }

   function onError(err) {
      if (typeof err !== 'object' && err.includes('TokenExpiredError')) {
         errorCheck(err, navigate, setToastProps, setShowToast)
      } else {
        console.log(err)
      }
   }

   const canRead = hasPermission(
        moduleOperationsForReadPermissionCheck,
        "Activity List",
        "read",
      );
    
      if (Object.keys(moduleOperationsForReadPermissionCheck).length > 0 && !canRead) {
        return (
          <div
            className="text-center p-4"
            style={{
              marginTop: "50px",
              marginBottom: "50px",
              fontSize: "16px",
            }}
          >
            No read permission found in assigned ACL
          </div>
        );
      }

   if (loading) {
      return <Loader />
   }

   return (
      <>
         <div>
            <Row>
               <Col sm="12">
                  <Card>
                     <Card.Header className="d-block justify-content-between">
                        <div className="header-title">
                           <h4 className="card-title">Activity List</h4>
                        </div>
                     </Card.Header>
                     <Card.Body className="px-0">
                     <div className="d-flex align-items-center px-3 mb-3" style={{ gap: "12px" }}>
                       
                        <Form.Group className="mb-0" style={{ flex: "0 0 300px" }}>
                           <Form.Control
                              style={{
                                height: "45px",
                                border: "1px solid #ced4da",
                                fontSize: "15px",
                    }}
                              placeholder = 'Search by Name...'
                              type="text"
                              maxLength={100}
                              value={searchValue} 
                              onChange={(e) => setSearchValue(e.target.value)}
                              required
                           />
                        </Form.Group>
                         {operationList.length > 0 &&
                           <Button 
                           label="Export Data" 
                           onClick={handleExport} 
                           className="p-button-active p-button-sm" 
                           style={{ height: "45px", gap: "8px" }} 
                           disabled={buttonDisable} 
                        >
                           &nbsp;
                           {buttonDisable && (
                              <span className="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
                           )}
                        </Button>
                        }

                            <Button 
                           label="Refresh" 
                           className="p-button-primary" 
                           onClick={handleRefresh}
                           style={{ height: "45px" }}
        />

                        </div>
                        <div className="scroll-container">
                           <div className="table-responsive border-bottom my-3">
                              <DataTable value={operationList} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={8} >
                                 <Column field="key" header="#"></Column>
                                 <Column field="module_name" filterField="module_name" header="Module Name" filter filterPlaceholder="Search by Module name" body={(rowData) => rowData.module_name?.toUpperCase()} ></Column>
                                 <Column field="action" filterField="action" header="Action" filter filterPlaceholder="Search by action" body={(rowData) => rowData.action?.toUpperCase()} ></Column>
                                 <Column field="creator.username" filterField="creator.username" header="Action By" filter filterPlaceholder="Search by Created By"></Column>
                                 <Column field="created_at" header="Date" body={(rowData) =>
                                    new Date(rowData.created_at).toLocaleString("en-IN", {
                                       day: "2-digit",
                                       month: "short",
                                       year: "numeric",
                                       hour: "2-digit",
                                       minute: "2-digit",
                                       second: "2-digit",
                                    })
                                 }></Column>
                              </DataTable>
                           </div>
                        </div>
                     </Card.Body>
                  </Card>
               </Col>
            </Row>
         </div>

         <RenderDeleteModal show={enableDeleteModal} setShow={setEnableDeleteModal} setConfirmDelete={setConfirmDelete} />

         <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} />

      </>
   )

}